import React, { useEffect, useState, createContext, useContext } from 'react';
interface PopupContextType {
  isEmailPopupOpen: boolean;
  openEmailPopup: () => void;
  closeEmailPopup: () => void;
}
const PopupContext = createContext<PopupContextType | undefined>(undefined);
export const usePopup = () => {
  const context = useContext(PopupContext);
  if (context === undefined) {
    throw new Error('usePopup must be used within a PopupProvider');
  }
  return context;
};
export const PopupProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [isEmailPopupOpen, setIsEmailPopupOpen] = useState(false);
  // Check if the user has seen the popup before and add scroll listener
  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('hasSeenEmailPopup');
    if (!hasSeenPopup) {
      // Show popup after user scrolls down
      const handleScroll = () => {
        // Show popup when user has scrolled down 30% of viewport height
        const scrollThreshold = window.innerHeight * 0.3;
        if (window.scrollY > scrollThreshold && !isEmailPopupOpen) {
          setIsEmailPopupOpen(true);
          // Remove scroll listener once popup is shown
          window.removeEventListener('scroll', handleScroll);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [isEmailPopupOpen]);
  const openEmailPopup = () => {
    setIsEmailPopupOpen(true);
  };
  const closeEmailPopup = () => {
    setIsEmailPopupOpen(false);
    // Mark that the user has seen the popup
    localStorage.setItem('hasSeenEmailPopup', 'true');
  };
  return <PopupContext.Provider value={{
    isEmailPopupOpen,
    openEmailPopup,
    closeEmailPopup
  }} data-id="element-293">
      {children}
    </PopupContext.Provider>;
};